function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createResourceId, parseResourceId } from ".";
import { mapObjectMapValues } from "../../utils";
import { createResourceVariantValidator } from "../resources/SWBaseResourceVariant";
/** @public */ /** @internal */ export const rootResourceVariantVersions = {};
/** @internal */ export const rootResourceVariantMigrations = defineMigrations({});
/** @public */ export function isResourceVariant(record) {
    if (!record) return false;
    return record.typeName === "resource_variant";
}
/** @public */ export function isResourceVariantId(id) {
    if (!id) return false;
    return id.startsWith("resource_variant:");
}
export const parseResourceVariantId = (id)=>{
    if (!id) return undefined;
    if (!id.startsWith("resource_variant:")) return undefined;
    const parts = id.replace("resource_variant:", "").split(":");
    const variant = parts.pop();
    if (!variant) return undefined;
    const parsedResourceId = parseResourceId("resource:" + parts.join(":"));
    if (!parseResourceId) return undefined;
    return _object_spread_props(_object_spread({}, parsedResourceId), {
        variant
    });
};
// /** @public */
// export function createResourceVariantId(id?: string): SWResourceVariantId {
//   return `resource_variant:${id ?? nanoid()}` as SWResourceVariantId
// }
export const createResourceVariantIdPrefix = (type)=>`resource_variant:${type}:`;
// 'resource_variant:<type>:<name>:<org-id>:global|organization:0'
export function createResourceVariantId({ type, name, organizationId, scope, variant }) {
    const resourceId = createResourceId({
        type,
        name,
        organizationId,
        scope
    });
    return `resource_variant:${resourceId.replace("resource:", "")}:${variant}`;
}
/** @internal */ export function createResourceVariantRecordType(resource_variants) {
    return createRecordType("resource_variant", {
        migrations: undefined,
        // defineMigrations({
        // currentVersion: rootResourceVariantMigrations.currentVersion,
        // firstVersion: rootResourceVariantMigrations.firstVersion,
        // migrators: rootResourceVariantMigrations.migrators,
        // subTypeKey: "type",
        // subTypeMigrations: mapObjectMapValues(
        //   resource_variants,
        //   (_, v) => v.migrations ?? defineMigrations({})
        // ),
        // }),
        scope: "session",
        validator: T.model("resource_variant", T.union("type", mapObjectMapValues(resource_variants, (type, { props, meta })=>createResourceVariantValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
